import MaterialReactTable, {
  MRT_ColumnDef,
  MRT_RowSelectionState,
} from "material-react-table";
import {
  EyeOff24Filled,
  DocumentBulletList20Regular,
  Dismiss24Regular,
  Eye24Filled,
  Attach20Regular,
} from "@fluentui/react-icons";
import { useEffect, useMemo, useState } from "react";
import { setDialogModalOptions } from "../../../redux/modelDialogReducer";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../../redux/store";
import apiServices from "../../../service";
import {
  Button,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  OverlayDrawer,
} from "@fluentui/react-components";
import ReactQuillComponent from "../../../components/ReactQuillComponent";
import {
  convertStringToArray,
  formatedDate,
  formattedTime,
  getClientNoteCategories,
  getClientType,
  getYes_NoConversion,
  isObjectEmpty,
  stripHtmlTags,
} from "../../../utils";
import ContentLoader from "../../../components/Loader/ContentLoader";
import ModalDialog from "../../../components/ModalDialog";
import ASCButton from "../../../components/Button";
import { clientDetails } from "../../../shared/contactHistory";
import {
  General,
  healthAssurance,
  incomeProtection,
  Investments,
  lifeAssurance,
  loansLeaseHP,
  Mortages,
  pensions,
  savingsPlans,
  unitLinked,
} from "../../../shared/actionlistDetails";
import MultiLineText from "../../../components/TableMultiLineData/MultiLineData";
import { useNavigate } from "react-router-dom";

interface PropsType {
  [x: string]: any;
}

const ContactHistory = (props: PropsType) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch: AppDispatch = useDispatch();
  const [noteData, setNoteData] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [caseData, setCaseData] = useState([]);
  const [showActions, setShowActions] = useState<Boolean>(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [contactHistoryItems, setContactHistoryItems] = useState<any>([]);
  const [contactHistoryData, setContactHistoryData] = useState<any>([]);
  const [selectedItem, setSelectedItem] = useState<any | {}>({});
  const [clientDataById, setClientDataById] = useState<PropsType>([]);
  const [activeRowItemDetail, setActiveRowItemDetail] = useState<any | {}>({});
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const selectedRowId = Object.keys(rowSelection)[0];
    if (!selectedRowId) return;

    const selectedRowData = contactHistoryItems.find(
      (item: any) => item.rowId === selectedRowId
    );

    if (selectedRowData) {
      setSelectedItem(selectedRowData);
    }
  }, [rowSelection, contactHistoryItems]);

  useEffect(() => {
    const notes = contactHistoryItems.filter(
      (item: any) => item.type === "Notes"
    );
    const clients = contactHistoryItems.filter(
      (item: any) => item.type === "Client"
    );
    const cases = contactHistoryItems.filter(
      (item: any) => item.type === "Case"
    );

    setNoteData(notes);
    setClientData(clients);
    setCaseData(cases);
  }, [contactHistoryData]);

  useEffect(() => {
    getContactHistoryData(props.clientId);
  }, [props.clientId, showActions]);

  function getCaseCategory(
    categoryNumber: number,
    rowItem: { id: number; customer_id: number }
  ) {
    switch (categoryNumber) {
      case 2:
      case 3:
      case 4:
      case 5:
        apiServices.assets
          .getDetail(rowItem.id, rowItem.customer_id)
          .then(handleSuccessResponse)
          .catch(handleErrorResponse);
        break;

      case 1:
        apiServices.policy
          .getDetail(rowItem.id, rowItem.customer_id)
          .then(handleSuccessResponse)
          .catch(handleErrorResponse);
        break;

      case 6:
      case 7:
      case 8:
        apiServices.liability
          .getDetail(rowItem.id, rowItem.customer_id)
          .then(handleSuccessResponse)
          .catch(handleErrorResponse);
        break;

      default:
        console.warn("Unknown category:", categoryNumber);
    }
  }
  const generateUniqueId = () => {
    return `${Date.now()}-${Math.floor(Math.random() * 100000)}`;
  };
  const getContactHistoryData = (userId: string) => {
    setIsLoading(true);
    apiServices.clientHistory
      .getClientHistory(userId, showActions ? "" : "hide")
      .then((response) => {
        setIsLoading(false);
        if (response.data && response.data.data) {
          let resultData: any[] = [];

          // Handle response.data.data as either array or object
          const data = Array.isArray(response.data.data)
            ? response.data.data
            : [response.data.data];

          data.forEach((item: any) => {
            // Process notes
            if (item.notes) {
              item.notes.forEach((object: any) => {
                resultData.push({
                  rowId: generateUniqueId(),
                  date: object.note_date,
                  customer_id: object.customer_id,
                  id: object.note_id,
                  type: "Notes",
                  time: object.note_time,
                  category: getClientNoteCategories(object.category),
                  category_value: object.category,
                  contact_type: object.note_type,
                  note_text: object.note_text,
                  status: object.status,
                  file_link: object.file_link,
                  attachment_file: object.attachment_file,
                  assigned: "",
                });
              });
            }

            // Process client actions (only when showActions is true)
            if (item.client_action) {
              item.client_action.forEach((object: any) => {
                resultData.push({
                  rowId: generateUniqueId(),
                  category: "Client Action",
                  customer_id: object.customer_id,
                  id: object.appointment_id,
                  type: "Client",
                  date: object.appointment_date,
                  time: object.appointment_time,
                  contact_type: object.appointment_type,
                  note_text: object.appointment_note,
                  status: object.appointment_status,
                  file_link: "",
                  attachment_file: "",
                  assigned: object.appointment_assigned,
                });
              });
            }

            // Process case actions (only when showActions is true)
            if (item.case_action) {
              item.case_action.forEach((object: any) => {
                resultData.push({
                  rowId: generateUniqueId(),
                  customer_id: object.customer_id,
                  id: object.case_id,
                  business_id: object.business_id,
                  type: "case_action",
                  date: object.business_date,
                  time: "",
                  category: "Case Action",
                  contact_type: object.case_type || "",
                  note_text: object.business_action,
                  status: object.business_status,
                  business_category: object.business_category,
                  assigned: object.business_assigned,
                  case_type: object.case_type,
                  file_link: "",
                  attachment_file: "",
                });
              });
            }
          });

          setContactHistoryItems(resultData);
          setContactHistoryData(resultData);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const columns = useMemo<MRT_ColumnDef<{ [key: string]: any }>[]>(
    () => [
      {
        accessorKey: "date",
        header: "Date",
        Cell: ({ row }: any) => <>{formatedDate(row.original.date)}</>,
      },
      {
        accessorKey: "time",
        header: "Time",
        Cell: ({ row }: any) => <>{formattedTime(row.original.time)}</>,
      },
      {
        accessorKey: "category",
        header: "Category",
      },
      {
        accessorKey: "contact_type",
        header: "Contact Type",
      },
      {
        accessorKey: "note_text",
        header: "Note Text",
        Cell: ({ row }: any) => (
          <>
            <ReactQuillComponent value={row.original.note_text} />
          </>
        ),
      },
      {
        accessorKey: "file_link",
        header: "File Link",
        Cell: ({ row }: any) => {
          return (
            <div>
              {(row.original.file_link && row.original.file_link != "") ||
                (row.original.attachment_file &&
                  row.original.attachment_file !== undefined &&
                  row.original.attachment_file !== null &&
                  row.original.attachment_file !== "") ? (
                <span>
                  <Attach20Regular />
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "assigned",
        header: "Assigned",
      },
      {
        accessorKey: "status",
        header: "Status",
      },
    ],
    []
  );

  const handleErrorResponse = (err: any) => {
    console.log(err);
  };

  useEffect(() => {
    if (!isObjectEmpty(selectedItem)) {
      if (selectedItem.type === "case_action") {
        const categoryNum = Number(selectedItem.business_category);
        getCaseCategory(categoryNum, selectedItem);
      } else {
        getClientDetail(selectedItem.customer_id);
      }
    }
  }, [selectedItem]);

  const handleSuccessResponse = (response: any) => {
    if (
      response.data &&
      !response.data.isError &&
      !isObjectEmpty(response.data.data)
    ) {
      setActiveRowItemDetail(response.data.data);
    }
  };

  const getClientDetail = (id: string) => {
    apiServices.client
      .getDetail(id)
      .then((response: any) => {
        setClientDataById(response.data.data);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  const renderClientType = (type: number) => (type ? getClientType(type) : "-");
  const renderDate = (date: string) => (date ? formatedDate(date) : "-");
  const renderRichText = (text: string) =>
    text ? <ReactQuillComponent value={text} /> : "-";
  const renderYesorNo = (value: number) =>
    value ? getYes_NoConversion(value) : "-";
  const Details = (selectedItem: any) => {
    if (selectedItem.type === "Notes" || selectedItem.type === "Client") {
      return (
        <div>
          {Object.keys(clientDataById).length !== 0 &&
            clientDetails.length > 0 &&
            clientDetails.map((client: any) => (
              <div key={client.lifeAssurance_id} className="details">
                <p className="details_label">{client.label} :</p>
                <p>
                  {(() => {
                    switch (client.value) {
                      case "address_1":
                        return (
                          <MultiLineText
                            lines={[
                              clientDataById.NameAndAddress?.address_1 || "-",
                              clientDataById.NameAndAddress?.address_2,
                              clientDataById.NameAndAddress?.address_3,
                            ]}
                          />
                        );
                      case "date_of_birth":
                        return renderDate(clientDataById.date_of_birth);
                      case "fact_find_completed":
                        return renderDate(clientDataById.fact_find_completed);
                      case "terms_of_business_sent":
                        return renderDate(
                          clientDataById.terms_of_business_sent
                        );
                      case "idd":
                        return renderDate(clientDataById.idd);
                      case "menu":
                        return renderDate(clientDataById.menu);
                      case "data_protection_form_sent":
                        return renderRichText(
                          clientDataById.data_protection_form_sent
                        );
                      case "review_date":
                        return renderRichText(clientDataById.review_date);
                      case "review_completed":
                        return renderRichText(clientDataById.review_completed);
                      case "review_note":
                        return renderRichText(clientDataById.review_note);
                      case "note_text":
                        return renderRichText(clientDataById.note_text);
                      default:
                        return (
                          clientDataById.NameAndAddress[client.value] ||
                          clientDataById.Contact[client.value] ||
                          clientDataById.Nationality[client.value] ||
                          clientDataById.Personal[client.value] ||
                          "-"
                        );
                    }
                  })()}
                </p>
              </div>
            ))}
        </div>
      );
    } else if (selectedItem.type === "case_action") {
      if (selectedItem.business_category === 2) {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              unitLinked.length > 0 &&
              unitLinked.map((investmentdata: any) => (
                <div key={investmentdata.lifeAssurance_id} className="details">
                  <p className="details_label">{investmentdata.label} :</p>
                  <p>
                    {(() => {
                      switch (investmentdata.value) {
                        case "policy_holder":
                          return renderClientType(
                            activeRowItemDetail.policy_holder
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note
                          );
                        case "admin_note":
                          return renderRichText(activeRowItemDetail.admin_note);
                        case "note_text":
                          return renderRichText(activeRowItemDetail.note_text);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note
                          );
                        default:
                          return (
                            activeRowItemDetail[investmentdata.value] || "-"
                          );
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      } else if (selectedItem.business_category === 6) {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              Mortages.length > 0 &&
              Mortages.map((Mortagesdata: any) => (
                <div key={Mortagesdata.Mortages_id} className="details">
                  <p className="details_label">{Mortagesdata.label} </p>
                  <p>
                    {(() => {
                      switch (Mortagesdata.value) {
                        case "joint_indicator":
                          return renderClientType(
                            activeRowItemDetail.joint_indicator
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "amount_outstanding_date":
                          return renderDate(
                            activeRowItemDetail.amount_outstanding_date
                          );
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note
                          );
                        case "note_text":
                          return renderRichText(activeRowItemDetail.note_text);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note
                          );
                        case "provider_address1":
                          return (
                            <MultiLineText
                              lines={[
                                activeRowItemDetail?.provider_address1 || "-",
                                activeRowItemDetail?.provider_address2,
                                activeRowItemDetail?.provider_address3,
                              ]}
                            />
                          );
                        case "property_address1":
                          return (
                            <MultiLineText
                              lines={[
                                activeRowItemDetail?.property_address1 || "-",
                                activeRowItemDetail?.property_address2,
                                activeRowItemDetail?.property_address3,
                              ]}
                            />
                          );
                        default:
                          return activeRowItemDetail[Mortagesdata.value] || "-";
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      } else if (selectedItem.business_category === 7) {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              loansLeaseHP.length > 0 &&
              loansLeaseHP.map((loans: any) => (
                <div key={loans.Mortages_id} className="details">
                  <p className="details_label">{loans.label} </p>
                  <p>
                    {(() => {
                      switch (loans.value) {
                        case "joint_indicator":
                          return renderClientType(
                            activeRowItemDetail.joint_indicator
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "amount_outstanding_date":
                          return renderDate(
                            activeRowItemDetail.amount_outstanding_date
                          );
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note
                          );
                        case "note_text":
                          return renderRichText(activeRowItemDetail.note_text);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note
                          );
                        case "provider_address1":
                          return (
                            <MultiLineText
                              lines={[
                                activeRowItemDetail?.provider_address1 || "-",
                                activeRowItemDetail?.provider_address2,
                                activeRowItemDetail?.provider_address3,
                              ]}
                            />
                          );
                        case "property_address1":
                          return (
                            <MultiLineText
                              lines={[
                                activeRowItemDetail?.property_address1 || "-",
                                activeRowItemDetail?.property_address2,
                                activeRowItemDetail?.property_address3,
                              ]}
                            />
                          );
                        default:
                          return activeRowItemDetail[loans.value] || "-";
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      } else if (selectedItem.business_category === 1) {
        if (selectedItem.case_type === "Life Assurance") {
          return (
            <div>
              {Object.keys(activeRowItemDetail).length !== 0 &&
                lifeAssurance.length > 0 &&
                lifeAssurance.map((policyLA: any) => (
                  <div key={policyLA.lifeAssurance_id} className="case_details">
                    <p className="details_label">{policyLA.label} </p>
                    <p>
                      {(() => {
                        switch (policyLA.value) {
                          case "policy_holder":
                            return renderClientType(
                              activeRowItemDetail.policy_holder
                            );
                          case "mortgage_link":
                            return renderYesorNo(
                              activeRowItemDetail.mortgage_link
                            );
                          case "start_date":
                            return renderDate(activeRowItemDetail.start_date);
                          case "end_date":
                            return renderDate(activeRowItemDetail.end_date);
                          case "status_date":
                            return renderDate(activeRowItemDetail.status_date);
                          case "valuation_date":
                            return renderDate(
                              activeRowItemDetail.valuation_date
                            );
                          case "provider_note":
                            return renderRichText(
                              activeRowItemDetail.provider_note
                            );
                          case "benefit_text":
                            return renderRichText(
                              activeRowItemDetail.benefit_text
                            );
                          case "in_trust_note":
                            return renderRichText(
                              activeRowItemDetail.in_trust_note
                            );
                          case "admin_note":
                            return renderRichText(
                              activeRowItemDetail.admin_note
                            );
                          case "report_note":
                            return renderRichText(
                              activeRowItemDetail.report_note
                            );
                          default:
                            return activeRowItemDetail[policyLA.value] || "-";
                        }
                      })()}
                    </p>
                  </div>
                ))}
            </div>
          );
        } else if (selectedItem.case_type === "Pensions") {
          return (
            <div>
              {Object.keys(activeRowItemDetail).length !== 0 &&
                pensions.length > 0 &&
                pensions.map((policypensions: any) => (
                  <div
                    key={policypensions.lifeAssurance_id}
                    className="details"
                  >
                    <p className="details_label">{policypensions.label} </p>
                    <p>
                      {(() => {
                        switch (policypensions.value) {
                          case "policy_holder":
                            return renderClientType(
                              activeRowItemDetail.policy_holder
                            );
                          case "start_date":
                            return renderDate(activeRowItemDetail.start_date);
                          case "end_date":
                            return renderDate(activeRowItemDetail.end_date);
                          case "status_date":
                            return renderDate(activeRowItemDetail.status_date);
                          case "valuation_date":
                            return renderDate(
                              activeRowItemDetail.valuation_date
                            );
                          case "provider_note":
                            return renderRichText(
                              activeRowItemDetail.provider_note
                            );
                          case "benefit_text":
                            return renderRichText(
                              activeRowItemDetail.benefit_text
                            );
                          case "in_trust_note":
                            return renderRichText(
                              activeRowItemDetail.in_trust_note
                            );
                          case "admin_note":
                            return renderRichText(
                              activeRowItemDetail.admin_note
                            );
                          case "report_note":
                            return renderRichText(
                              activeRowItemDetail.report_note
                            );
                          default:
                            return (
                              activeRowItemDetail[policypensions.value] || "-"
                            );
                        }
                      })()}
                    </p>
                  </div>
                ))}
            </div>
          );
        } else if (selectedItem.case_type === "Savings Plans") {
          return (
            <div>
              {Object.keys(activeRowItemDetail).length !== 0 &&
                savingsPlans.length > 0 &&
                savingsPlans.map((policySP: any) => (
                  <div key={policySP.lifeAssurance_id} className="details">
                    <p className="details_label">{policySP.label} </p>
                    <p>
                      {(() => {
                        switch (policySP.value) {
                          case "policy_holder":
                            return renderClientType(
                              activeRowItemDetail.policy_holder
                            );
                          case "start_date":
                            return renderDate(activeRowItemDetail.start_date);
                          case "end_date":
                            return renderDate(activeRowItemDetail.end_date);
                          case "status_date":
                            return renderDate(activeRowItemDetail.status_date);
                          case "valuation_date":
                            return renderDate(
                              activeRowItemDetail.valuation_date
                            );
                          case "provider_note":
                            return renderRichText(
                              activeRowItemDetail.provider_note
                            );
                          case "benefit_text":
                            return renderRichText(
                              activeRowItemDetail.benefit_text
                            );
                          case "in_trust_note":
                            return renderRichText(
                              activeRowItemDetail.in_trust_note
                            );
                          case "admin_note":
                            return renderRichText(
                              activeRowItemDetail.admin_note
                            );
                          case "report_note":
                            return renderRichText(
                              activeRowItemDetail.report_note
                            );
                          default:
                            return activeRowItemDetail[policySP.value] || "-";
                        }
                      })()}
                    </p>
                  </div>
                ))}
            </div>
          );
        } else if (selectedItem.case_type === "Income Protection") {
          return (
            <div>
              {Object.keys(activeRowItemDetail).length !== 0 &&
                incomeProtection.length > 0 &&
                incomeProtection.map((policyIP: any) => (
                  <div key={policyIP.lifeAssurance_id} className="details">
                    <p className="details_label">{policyIP.label} </p>
                    <p>
                      {(() => {
                        switch (policyIP.value) {
                          case "policy_holder":
                            return renderClientType(
                              activeRowItemDetail.policy_holder
                            );
                          case "start_date":
                            return renderDate(activeRowItemDetail.start_date);
                          case "end_date":
                            return renderDate(activeRowItemDetail.end_date);
                          case "status_date":
                            return renderDate(activeRowItemDetail.status_date);
                          case "valuation_date":
                            return renderDate(
                              activeRowItemDetail.valuation_date
                            );
                          case "provider_note":
                            return renderRichText(
                              activeRowItemDetail.provider_note
                            );
                          case "benefit_text":
                            return renderRichText(
                              activeRowItemDetail.benefit_text
                            );
                          case "in_trust_note":
                            return renderRichText(
                              activeRowItemDetail.in_trust_note
                            );
                          case "admin_note":
                            return renderRichText(
                              activeRowItemDetail.admin_note
                            );
                          case "report_note":
                            return renderRichText(
                              activeRowItemDetail.report_note
                            );
                          default:
                            return activeRowItemDetail[policyIP.value] || "-";
                        }
                      })()}
                    </p>
                  </div>
                ))}
            </div>
          );
        } else if (selectedItem.case_type === "Health Assurance") {
          return (
            <div>
              {Object.keys(activeRowItemDetail).length !== 0 &&
                healthAssurance.length > 0 &&
                healthAssurance.map((policyHA: any) => (
                  <div key={policyHA.healthAssurance_id} className="details">
                    <p className="details_label">{policyHA.label} </p>
                    <p>
                      {(() => {
                        switch (policyHA.value) {
                          case "policy_holder":
                            return renderClientType(
                              activeRowItemDetail.policy_holder
                            );
                          case "start_date":
                            return renderDate(activeRowItemDetail.start_date);
                          case "end_date":
                            return renderDate(activeRowItemDetail.end_date);
                          case "status_date":
                            return renderDate(activeRowItemDetail.status_date);
                          case "provider_note":
                            return renderRichText(
                              activeRowItemDetail.provider_note
                            );
                          case "benefit_text":
                            return renderRichText(
                              activeRowItemDetail.benefit_text
                            );
                          case "admin_note":
                            return renderRichText(
                              activeRowItemDetail.admin_note
                            );
                          case "report_note":
                            return renderRichText(
                              activeRowItemDetail.report_note
                            );
                          default:
                            return activeRowItemDetail[policyHA.value] || "-";
                        }
                      })()}
                    </p>
                  </div>
                ))}
            </div>
          );
        } else if (selectedItem.case_type === "General") {
          return (
            <div>
              {Object.keys(activeRowItemDetail).length !== 0 &&
                General.length > 0 &&
                General.map((policyGeneral: any) => (
                  <div key={policyGeneral.lifeAssurance_id} className="details">
                    <p className="details_label">{policyGeneral.label} :</p>
                    <p>
                      {(() => {
                        switch (policyGeneral.value) {
                          case "policy_holder":
                            return renderClientType(
                              activeRowItemDetail.policy_holder
                            );
                          case "start_date":
                            return renderDate(activeRowItemDetail.start_date);
                          case "end_date":
                            return renderDate(activeRowItemDetail.end_date);
                          case "status_date":
                            return renderDate(activeRowItemDetail.status_date);
                          case "provider_note":
                            return renderRichText(
                              activeRowItemDetail.provider_note
                            );
                          case "benefit_text":
                            return renderRichText(
                              activeRowItemDetail.benefit_text
                            );
                          case "in_trust_note":
                            return renderRichText(
                              activeRowItemDetail.in_trust_note
                            );
                          case "admin_note":
                            return renderRichText(
                              activeRowItemDetail.admin_note
                            );
                          case "report_note":
                            return renderRichText(
                              activeRowItemDetail.report_note
                            );
                          default:
                            return (
                              activeRowItemDetail[policyGeneral.value] || "-"
                            );
                        }
                      })()}
                    </p>
                  </div>
                ))}
            </div>
          );
        } else if (selectedItem.case_type === "Investments") {
          return (
            <div>
              {Object.keys(activeRowItemDetail).length !== 0 &&
                Investments.length > 0 &&
                Investments.map((policyIInvestments: any) => (
                  <div
                    key={policyIInvestments.Investments_id}
                    className="details"
                  >
                    <p className="details_label">{policyIInvestments.label} </p>
                    <p>
                      {(() => {
                        switch (policyIInvestments.value) {
                          case "policy_holder":
                            return renderClientType(
                              activeRowItemDetail.policy_holder
                            );
                          case "start_date":
                            return renderDate(activeRowItemDetail.start_date);
                          case "end_date":
                            return renderDate(activeRowItemDetail.end_date);
                          case "status_date":
                            return renderDate(activeRowItemDetail.status_date);
                          case "valuation_date":
                            return renderDate(
                              activeRowItemDetail.valuation_date
                            );
                          case "provider_note":
                            return renderRichText(
                              activeRowItemDetail.provider_note
                            );
                          case "benefit_text":
                            return renderRichText(
                              activeRowItemDetail.benefit_text
                            );
                          case "in_trust_note":
                            return renderRichText(
                              activeRowItemDetail.in_trust_note
                            );
                          case "admin_note":
                            return renderRichText(
                              activeRowItemDetail.admin_note
                            );
                          case "report_note":
                            return renderRichText(
                              activeRowItemDetail.report_note
                            );
                          default:
                            return (
                              activeRowItemDetail[policyIInvestments.value] ||
                              "-"
                            );
                        }
                      })()}
                    </p>
                  </div>
                ))}
            </div>
          );
        }
      }
    }
  };

  const editRecord = (row: any) => {
    const clientId = row.customer_id;
    const noteId = row.id;
    const categoryValue = Number(row.category_value);
    if (row.type === "Notes") {
      if (categoryValue >= 7 && categoryValue <= 21) {
        navigate(`/clients/${clientId}/fact-find-notes/${noteId}/edit`);
      } else {
        navigate(`/clients/${clientId}/contacts/notes/${noteId}/edit`);
      }
    } else if (row.type === "Client") {
      navigate(`/clients/${clientId}/contacts/client-action/${noteId}/edit`);
    } else if (row.type === "case_action") {
      // Determine section based on business_category
      let section = "policies";
      if (row.business_category === 2) {
        section = "assets";
      } else if (row.business_category === 6 || row.business_category === 7) {
        section = "liabilities";
      } else if (row.business_category === 1) {
        section = "policies";
      }
      // Use row.id as caseId, row.business_id as actionId
      const caseId = row.id;
      const actionId = row.business_id;
      const path = `/clients/${clientId}/${section}/${caseId}/actions/${actionId}/action/edit`;
      navigate(path);
    }
  };

  return isLoading ? (
    <ContentLoader />
  ) : (
    <>
      <div className="">
        <div className="">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginBottom: "0.4rem",
            }}
          >
            <ASCButton
              shape="rounded"
              onClick={() => {
                setIsOpen(true);
              }}
              size="medium"
              icon={<DocumentBulletList20Regular />}
              disabled={isObjectEmpty(selectedItem) ? true : false}
              label="Details"
            />
          </div>

          <div className="caseSummary">
            <MaterialReactTable
              columns={columns}
              data={contactHistoryItems}
              enableGlobalFilter={false}
              enableColumnActions={false}
              enableRowSelection
              enableMultiRowSelection={false}
              enableRowActions={false}
              positionToolbarAlertBanner="none"
              getRowId={(row) => row.rowId}
              muiTableBodyRowProps={({ row }: any) => ({
                onClick: row.getToggleSelectedHandler(),
                title: "Double-click here to edit the record",
                onDoubleClick: () => {
                  row.getToggleSelectedHandler();
                  editRecord(row.original);

                  // dispatch(
                  //   setDialogModalOptions({
                  //     open: true,
                  //     contact_history_data: row.original,
                  //     type: row.original.category,
                  //     case_type: row.original.case_type,
                  //     setActiveItem: props.setActiveItem,
                  //     activeClient: props.activeClient,
                  //     customerId: props.clientId,
                  //     close: {
                  //       onclick: () => {
                  //         dispatch(setDialogModalOptions({ open: false }));
                  //       },
                  //       label: "Cancel",
                  //     },
                  //   })
                  // );
                },
                sx: { cursor: "pointer" },
              })}
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  header: "Actions",
                  muiTableHeadCellProps: {
                    align: "center",
                  },
                  muiTableBodyCellProps: {
                    align: "center",
                  },
                },
              }}
              enableStickyHeader
              renderTopToolbarCustomActions={({ table }) => (
                <>
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_CTA_BUTTON
                  ).includes("case/client_action_btn") ? (
                    <Button
                      shape="rounded"
                      disabled={
                        !convertStringToArray(
                          process.env.REACT_APP_DISABLE_CTA_BUTTON
                        ).includes("case/client_action_btn")
                          ? false
                          : true
                      }
                      onClick={() => setShowActions(!showActions)}
                      size="medium"
                      icon={showActions ? <EyeOff24Filled /> : <Eye24Filled />}
                    >{`${showActions ? "Hide" : "Show"
                      } Case/Client Action`}</Button>
                  ) : (
                    ""
                  )}
                </>
              )}
              positionActionsColumn="last"
              state={{ rowSelection }}
              onRowSelectionChange={setRowSelection}
            />
          </div>
        </div>
        <OverlayDrawer
          position={"end"}
          open={isOpen}
          onOpenChange={(_, { open }) => setIsOpen(open)}
          className={"common-drawer"}
        >
          <DrawerHeader>
            <DrawerHeaderTitle
              action={
                <ASCButton
                  shape="rounded"
                  appearance="subtle"
                  aria-label="Close"
                  icon={<Dismiss24Regular />}
                  onClick={() => setIsOpen(false)}
                />
              }
            >
              Details
            </DrawerHeaderTitle>
          </DrawerHeader>
          <DrawerBody>{Details(selectedItem)}</DrawerBody>
        </OverlayDrawer>
      </div>
      <ModalDialog options={dialogModalOptions} />
    </>
  );
};

export default ContactHistory;
